
import { Mixins, Component, Watch } from "vue-property-decorator";
import Description from "./description.vue";

@Component({
    components: { Description }
})
export default class DescriptionBrandIndex extends Mixins() {

}
